import {cDisplay} from '../creator/cDisplay'
import { cGame } from '../creator/cGame';
import {cScene} from '../creator/cScene'
import { net } from '../creator/utils/net';


export class bookDisplay extends cDisplay {

  private MAX_PAGES: number = 57;
  private curIndex: number = 1;

  init(){
    super.init()
    console.log('INIT BOOK',cGame.current.state);

    console.log( net.serverUrl );


    (this.scene as cScene).ev.addListener('action',(type,action)=>{
      switch (action.command){
        case 'next_page':
          if (this.curIndex < this.MAX_PAGES){
            this.curIndex = this.curIndex + 1;
            cGame.current.state.set('currentBookPage',this.curIndex);
            this.loadPage();
          }          
          break;
        case 'prev_page':
          if (this.curIndex > 0){
            this.curIndex = this.curIndex - 1;
            cGame.current.state.set('currentBookPage',this.curIndex);
            this.loadPage();
          }          
          break;
        case 'zoom':
          var pg = (this.scene as cScene).getByName('bookpage');
          console.log(this.scene.input)
          if (action.options == 'yes'){
            pg.setInteractive({useHandCursor:true});
            this.scene.input.setDraggable(pg)
            this.scene.input.on('drag',(p:any,gameObj:any,x:number,y:number)=>{
              pg.x = x;
              pg.y = y;



              if (pg.x > 1500) pg.x = 1500
              if (pg.y > 1000) pg.y = 1000
               if (pg.x < 400) pg.x = 400
              if (pg.y < 0) pg.y = 0

              console.log(pg.x, pg.y)
            });  
          }else{
            pg.disableInteractive();
            this.scene.input.off('drag');  
          }






  
        // cS.input.on('dragend',(p:any, gameObj:any)=>{
        //   if (gameObj !== this.ref) return
        //   var r:cObject = this.ref as any;
        //   //r.dataItem.ofs = r.modules.layout.ofs;
        //   cS.events.emit(
        //     'debug_position', 
        //     this.data, 
        //     r.modules.layout.ofs, 
        //   )
        //   this.ref.emit('')
        // })


          break;
      }
    })


    setTimeout( ()=>{
      this.curIndex = cGame.current.state.get('currentBookPage',1)
      this.loadPage();
    },1)

  }

  buildScene(){    
    super.buildScene();      

    setTimeout(()=>{
      var l = (this.scene as cScene).getByName('bookpage')
      l.blendMode = Phaser.BlendModes.MULTIPLY;
      console.log('XX',l)

    })

  }

  loadPage(){
    var path = '/book/book_0' + (( this.curIndex < 10 ) ? '0'+this.curIndex : ''+this.curIndex) + '.jpg';
    var img = new Image(100,100);
    img.addEventListener('load',()=>{      
      this.scene.textures.remove('book_current_page');
      this.scene.textures.addImage('book_current_page', img);
      (this.scene as cScene).getByName('bookpage').setTexture('book_current_page');
    });
    img.crossOrigin = "Anonymous";
    img.src = net.serverUrl+path;
  }


}
